<template>

    <div>

        <!-- SIDE BAR SECTION -->
        <div class="fixed z-50">
                <adminSideBar/>
        </div>
    
    
    <!-- NAV BAR SECTION -->
        <nav class="sticky w-full z-40 top-0 " >
    
            <adminNavBar/>
    
        </nav>
    
    <!-- DASHBOARD -->
    
        <div class="flex bg-medalertBlue bg-opacity-10 w-full h-screen pb-12">
    
            
            <div class="mt-3 w-full ml-60 font-euclid">
    
                <div class=" flex   text-left font-medium text-lg mx-12 mt-4">
                    <div class="flex justify-center items-center py-1 px-2 bg-white content-center   rounded-xl">
                        <i class="ri-filter-3-fill"></i>
                        <h2 class="ml-2">Filter</h2>
                    </div>
                    <div class="mx-4" >
                        <form action="" class="flex">
                            <input type="search" class="w-full px-3 py-2 rounded-md">

                            <button class=" hover:bg-purple-500 bg-medalertBlue text-white font-semibold focus:border-purple-500 hover:text-white hover:bg-medalertOrange py-1 px-4 mx-4 border border-purple-500 hover:border-transparent rounded">Search</button>
                        </form>
                    </div>

                </div>
    
                <div>
                    <div class="bg-white h-auto  mx-12 rounded-md mt-8">
                        <table class="table w-full text-left mx-auto rounded-md table-auto">
                            <thead class="bg-gray-200 py-2 font-light rounded-md">
                                <tr class="text-gray-700 text-sm" >
                                    <th class="px-3 py-2">S/N</th>
                                    <th class="px-3 py-2">Name</th>
                                    <th class="px-3 py-2">Company Type</th>
                                    <th class="px-3 py-2">CAC Reg No</th>
                                    <th class="px-3 py-2">Verification</th>
                                    <th class="px-3 py-2">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(client, index) in allClients" :key="index">
                                    <td class="px-3 py-1">{{index + 1}}</td>
                                    <td class="px-3 py-1">{{client.name}}</td>
                                    <td class="px-3 py-1">{{client.type}}</td>
                                    <td class="px-3 py-1">{{client.cac_registration_number}}</td>
                                    <td class="px-3 py-1">{{client.is_verified}}</td>
                                    <td class="px-3 py-2"><button @click="reviewClient(client.id)" class="text-white bg-medalertBlue font-medium py-1 px-3 rounded-md hover:bg-medalertOrange   "> Review </button></td>
                                </tr>
                                
                            </tbody>
                        </table>
    
                    </div>
                </div>
                
            </div>
    
    
    
    
    
        </div>
    
    
    
    </div>
    
    
    
      
    </template>
    
    <script>
    
    import adminNavBar from '../components/AdminNavBar'
    import adminSideBar from '../components/AdminSideBar'
    import axios from 'axios';
    
    import { ref } from 'vue'
    import {useRouter} from 'vue-router'
    import { useStore } from "vuex";
    
    
    export default {
    
        components:{adminNavBar, adminSideBar},
        
    
        setup(){
            const router = useRouter();
            const success = ref("");
            const err = ref("");
            const allClients = ref([])
    
            const getAllClients = async () =>{
            try{
                const response = await axios.get(`/api/v1/clients?page-number=1&limit=100000`)
                let allRegClients = response.data.data
                console.log(allRegClients)
                allClients.value = allRegClients
            } catch(error){
                err.value = error.response?.data?.result?.message ?? "Erorr! could not fetch all client";
            }
            }

            const reviewClient = (id) => {
            router.push(`/client-details/${id}`);
            };
    
    
            return{
                getAllClients,
                allClients,
                reviewClient
            }
        },
    
        mounted(){
          this.getAllClients();
        }
    
    }
    </script>
    
    <style>
    
    </style>